import { FC } from "react";
import { PageHeader } from "../../components/PageHeader";
import { Environments } from "../../modules/Environments";
import "./style.css";

export const EnvironmentsPage: FC = () => {
  return (
    <div className="environments-page">
      <PageHeader
        header="List of environments"
        description="Type to filter the list. Click a column label to sort"
      />
      <Environments />
    </div>
  );
};
